import ReactDOM from 'react-dom';
import Header from '../components/header-ui';
import theme from '../theme';
import {MuiThemeProvider} from '@material-ui/core/styles';
import OutsideAnnouncement from '@gaia/components/header-ui/OutsideAnnouncement';

declare global {
    interface Window {
        HeaderUI: {
            initialize: (isMigratedRivtUser: boolean) => void;
        };
    }
}

export interface SpecialAnnouncement {
    message: string;
    uuid: string;
}

window.HeaderUI = {
    initialize(isMigratedRivtUser) {
        const container = document.querySelector('#base_header');
        const bannerContainer = document.querySelector('#base_banner');
        let specialAnnouncement: SpecialAnnouncement | null = null;

        if (container) {
            ReactDOM.render(
                <MuiThemeProvider theme={theme}>
                    <Header />
                </MuiThemeProvider>,
                container
            );
        }

        if (!bannerContainer) return;

        let chosenBanner: JSX.Element;

        // fetch banner.json from S3
        fetch('https://s3.amazonaws.com/static.gaiagps.com/banner.json')
            .then((response) => response.json())
            .then((announcement: SpecialAnnouncement) => {
                specialAnnouncement = announcement;

                // if the message is empty, don't display the special announcement
                if (!specialAnnouncement.message?.trim()) {
                    throw new Error('no message in banner.json');
                }

                chosenBanner = (
                    <MuiThemeProvider theme={theme}>
                        <OutsideAnnouncement
                            dismissable={false}
                            localStorageKey={`specialAnnouncement__${specialAnnouncement.uuid}`}
                            message={specialAnnouncement.message}
                        />
                    </MuiThemeProvider>
                );
            })
            .catch(() => {
                chosenBanner = isMigratedRivtUser ? (
                    <OutsideAnnouncement
                        dismissable={true}
                        localStorageKey='showMigratedAnnouncement'
                        message='Unlock Gaia GPS Premium, Trailforks Pro, &amp; Outside Watch'
                        href='/outsideplus/?utm_medium=banner&utm_source=website&utm_campaign=o-plus'
                        cta='Join Outside+'
                    />
                ) : (
                    <OutsideAnnouncement
                        dismissable={false}
                        localStorageKey=''
                        message='Merge your Gaia GPS and Outside account today to get all the benefits of Outside+'
                        href='/settings/#merge-accounts'
                        cta='View your account'
                    />
                );
            })
            .finally(() => {
                ReactDOM.render(
                    <MuiThemeProvider theme={theme}>
                        {chosenBanner}
                    </MuiThemeProvider>,
                    bannerContainer
                );
            });
    },
};
